import React from "react";
import classes from "./UserDetailComponent.module.css";
import { IoDiamond } from "react-icons/io5";
import { imageUrl } from "@/config/apiUrl";
import { cn } from "@/helper/HelperFunction";

export default function UserDetailComponent({
  data,
  isPro = true,
  descType = "text",
  userClick,
}) {
  return (
    <div
      className={cn(classes.userDetail, userClick && classes.clickable)}
      onClick={(e) => {
        e.stopPropagation();
        if (userClick) {
          userClick();
        }
      }}
    >
      {data?.image && (
        <img
          src={data?.image ? imageUrl(data?.image) : "/images/user_image.png"}
          alt={data?.name}
        />
      )}
      <div>
        <h4>{data?.title}</h4>
        {data?.description && (
          <p
            className={cn(descType === "link" && classes.link)}
            onClick={(e) => {
              e.stopPropagation();
              if (descType === "link" && data?.description) {
                window.open(data?.description, "_blank");
              }
            }}
          >
            {data?.description}
          </p>
        )}
      </div>
      {isPro && <IoDiamond color="var(--main-color)" size={20} />}
    </div>
  );
}
